import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { fetchApiDataIfNeeded } from '../../../actions/api'
import { apiResourceEndpoint, buildRoutePath, routes } from '../../../constants/routes'

import { PaginationWrapper } from 'shs-pagination'

const mapStateToProps = (state) => {
    const paginator = state.paginator.adminAgents
    let agents = state.adminAgents
    if (paginator) {
        agents = agents
            .filter(field => paginator.itemIds.indexOf(field.id) !== -1)
            .sort((a, b) => {
                if (paginator.itemIds.indexOf(a.id) > paginator.itemIds.indexOf(b.id)) {
                    return 1
                }
                return -1
            })
    }
    return { agents, paginator }
}

const ListAgents = ({ dispatch, agents, paginator }) => {
    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/agents', 'LIST')))
    }, [dispatch])

    const renderAgentRow = (agent, index) => {
        return (
            <div key={agent.id} className="paginated-item">
                <span className="index">{index}</span>
                <Link to={buildRoutePath(routes.adminAgentsView, { agentId: agent.id })} className="main">
                    {agent.firstName} {agent.lastName}
                </Link>
            </div>
        )
    }

    const handlePaginationUpdate = (paginationParams) => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/agents', 'LIST'), paginationParams))
    }

    const renderAgents = () => {
        if (!paginator) {
            return null
        }
        let allAgents = []
        agents.forEach((agent, idx) => {
            let index = idx + ((paginator.currentPage - 1) * paginator.perPage) + 1
            allAgents.push(renderAgentRow(agent, index))
        })
        return (
            <PaginationWrapper
                paginator={paginator}
                controls={{ search: { enabled: true, collapsed: true } }}
                callbackFX={handlePaginationUpdate}
                countOptions={[5, 10, 20]}>
                {allAgents}
            </PaginationWrapper>
        )
    }

    return (
        <div>
            <h1>Agents</h1>
            {renderAgents()}
        </div>
    )
}

export default connect(mapStateToProps)(ListAgents)
